import HideOnNative from '@/common/HideOnNative';
import Filters from '@/srp/MainLayout/Filters';
import SearchBar from '@/srp/MainLayout/SearchBar';
import Modals from '@/srp/Modals';
import Breadcrumbs from '@/srp/SEOSection/BreadCrumbs';
import { useIsDesktop, useIsMobile } from '~/context/common/DeviceContext';
import { useConfiguration } from '~/context/common/StaticContext';
import { useHasInventoryError } from '~/context/srp/InventoryContext';
import NativeError from '~/native/srp/NativeError';
import type { SeoProps } from '~/server-props/srp/contracts';
import DeliveryUnavailableBanner from './DeliveryUnavailableBanner';
import HeaderOverlay from './HeaderOverlay';
import { Container, FiltersResultsContainer, Main } from './MainLayout.styles';
import QuickFilters from './QuickFilters';
import QuickMenu from './QuickMenu';
import SearchTools from './SearchTools';
import Banner from '../Banners/Banner';
import { ResultsSection } from '../ResultsSection';
import ContentResultsResearch from '../SEOSection';
import ShowConditionally from '../ShowConditionally';

function useDisableSeo() {
  const { disableSeoLinks } = useConfiguration();

  return disableSeoLinks;
}

type OwnProps = {
  initialSeoProps?: SeoProps;
};

export default function MainLayout({ initialSeoProps }: OwnProps) {
  const disableSeo = useDisableSeo();
  const hasInventoryError = useHasInventoryError();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  return (
    <div className="relative m-auto max-w-[1800px]">
      <ShowConditionally dealership={false}>
        <HeaderOverlay />
      </ShowConditionally>
      <NativeError />
      <DeliveryUnavailableBanner />
      <Container>
        <FiltersResultsContainer>
          <Filters />
          {!isDesktop && <SearchBar />}
          <Main id="srp-main-content">
            {isDesktop && <SearchBar />}
            <ShowConditionally dealership={false}>
              {isMobile && <QuickMenu />}

              <QuickFilters />

              <SearchTools />
            </ShowConditionally>

            <div className="relative z-0 sm:p-0">
              {!hasInventoryError && <Banner />}
              <ResultsSection />
            </div>
          </Main>
        </FiltersResultsContainer>
      </Container>
      <HideOnNative>
        <Breadcrumbs />
      </HideOnNative>
      <Modals />
      <HideOnNative>
        <ShowConditionally dealership={false}>
          {disableSeo ? null : (
            <ContentResultsResearch initialSeoProps={initialSeoProps} />
          )}
        </ShowConditionally>
      </HideOnNative>
    </div>
  );
}
